export default __webpack_public_path__ + "static/media/Flowchart-01.791af4ab.png";